import { inject } from "@angular/core";
import { CanActivateFn } from "@angular/router";
import { FilerTypeEnum } from "src/app/app.model";
import { FilerInformationService } from "../services";
import { map } from "rxjs/operators";

export function filerTypeGuard(forType: FilerTypeEnum): CanActivateFn {
    return () => {
        const filer = inject(FilerInformationService);

        return filer.current$.pipe(map((it) => filer.isAdmin || it?.filerTypeId === forType));
    };
}
